if (!customElements.get("lumihi-size-cards")) {
  customElements.define(
    "lumihi-size-cards",
    class extends HTMLElement {
      connectedCallback() {
        this.variantPicker =
          this.closest("product-info")?.querySelector("variant-selects");
        this.addEventListener("click", this.onCardClick);
        this.variantPicker?.addEventListener("change", this.syncActiveCard);
        this.syncActiveCard();
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onCardClick);
        this.variantPicker?.removeEventListener("change", this.syncActiveCard);
      }

      normalize = (value) =>
        String(value || "")
          .trim()
          .toLocaleLowerCase();

      getSelectedValues = () => {
        if (!this.variantPicker) return [];
        return Array.from(
          this.variantPicker.querySelectorAll(
            'input[type="radio"]:checked, select',
          ),
        )
          .map((control) =>
            control.tagName === "SELECT" ? control.value : control.value,
          )
          .map(this.normalize);
      };

      syncActiveCard = () => {
        const selectedValues = this.getSelectedValues();
        this.querySelectorAll("[data-size-card]").forEach((card) => {
          const active = selectedValues.includes(
            this.normalize(card.dataset.variantValue),
          );
          card.classList.toggle("is-selected", active);
          card.setAttribute("aria-pressed", String(active));
        });
      };

      onCardClick = (event) => {
        const card = event.target.closest("[data-size-card]");
        if (!card || !this.contains(card) || !this.variantPicker) return;
        const targetValue = this.normalize(card.dataset.variantValue);
        const radios = Array.from(
          this.variantPicker.querySelectorAll('input[type="radio"]'),
        );
        const radio = radios.find(
          (input) => this.normalize(input.value) === targetValue,
        );
        if (radio) {
          if (radio.disabled) return;
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }
        const selects = Array.from(
          this.variantPicker.querySelectorAll("select"),
        );
        const select = selects.find((item) =>
          Array.from(item.options).some(
            (option) => this.normalize(option.value) === targetValue,
          ),
        );
        if (!select) return;
        const option = Array.from(select.options).find(
          (item) => this.normalize(item.value) === targetValue,
        );
        if (!option?.disabled) {
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      };
    },
  );
}
